export type ProjectDetailShellState = {
  projectUuid: string;
  projectName: string;
};

let projectDetailShellState: ProjectDetailShellState | null = null;

export const updateProjectDetailShellState = (
  nextState: ProjectDetailShellState | null,
) => {
  projectDetailShellState = nextState;
};

export const getProjectDetailShellState = () => projectDetailShellState;
